import { render, staticRenderFns } from "./ButtonOferta.vue?vue&type=template&id=2c7916f0"
import script from "./ButtonOferta.vue?vue&type=script&lang=ts"
export * from "./ButtonOferta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports